/**
 * Shared types and utilities for websocket middleware handlers.
 */

import type { Dispatch, MiddlewareAPI, UnknownAction } from '@reduxjs/toolkit'

export type WebSocketStoreApi = MiddlewareAPI<Dispatch<UnknownAction>>

interface MessageEntityShape {
  messageRunId?: string
  type?: string
  delegationTargetList?: string[]
  isDelegationComplete?: boolean
}

interface WebSocketRootState {
  chat: {
    activeConversationId: string | null
    messageEntities: Record<string, MessageEntityShape>
  }
}

export const isActiveConversation = (store: WebSocketStoreApi, conversationId: string): boolean => {
  const state = store.getState() as WebSocketRootState
  return state.chat.activeConversationId === conversationId
}

export const isEntityCreated = (store: WebSocketStoreApi, entityId: string): boolean => {
  const state = store.getState() as WebSocketRootState
  return Boolean(state.chat.messageEntities[entityId])
}

export const findEntityIdByMessageRunId = (
  store: WebSocketStoreApi,
  messageRunId: string
): string | null => {
  if (!messageRunId) return null
  const state = store.getState() as WebSocketRootState
  for (const [entityId, entity] of Object.entries(state.chat.messageEntities)) {
    if (entity.messageRunId === messageRunId) return entityId
  }
  return null
}
